module.exports = __webpack_public_path__ + "img/gritify-logo-bg.1f2f2d3.svg";